import { mutationGenerator } from "@shared/libs/react-query/query.hooks";

import { registerDevice } from "./index";

// Mutation for device registration (POST request)
export const useRegisterDevice = mutationGenerator(registerDevice);
